import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciDialogComponent } from './luci-dialog.component';
import { AngularDraggableModule } from 'angular2-draggable';

@NgModule({
  declarations: [LuciDialogComponent],
  exports: [LuciDialogComponent],
  imports: [
    CommonModule,
    AngularDraggableModule
  ]
})
export class LuciDialogModule { }
